import {dispatch} from 'd3-dispatch';
import Default from '../default/';
import {setMethodsFromAttrs, rebindOnMethod} from '../../modules/util';
import _munge from './_munge';
import _map from './_map';
import _scale from './_scale';
import _mark from './_mark';
// import _tooltip from './marker-maps/_tooltip';
const latMeasure = {field: '__--daisy-lat--__'};
const lngMeasure = {field: '__--daisy-lng--__'};

const size = {range: [0.5, 4], scale: 'linear', reverse: false};
const conditions = ['normal', 'point'];
const _attrs = {
  addr: false,
  mapBaseType: 'ROADMAP',// ROADMAP SKYVIEW HYBRID
  overlayMapType: null, // OVERLAY TERRAIN TRAFFIC BICYCLE BICYCLE_HYBRID USE_DISTRICT
  size: size,
};

class MarkerMap extends Default {
  constructor() {
    super(_attrs);
    this.__execs__.dispatch = dispatch('loading', 'end');
    rebindOnMethod(this, this.__execs__.dispatch);
  }
}

function _markerMap() {
  let scatter =  new MarkerMap();
  return scatter;
}

function update() {
 // 데이터가 바뀐 경우

 // 데이터의 계산에 영향 주는 요소가 바뀐 경우

 // 다른 화면 요소가 바뀐 경우 
}

function isSized() {
  return this.condition() === conditions[0];
}

function renderLayout() { //완벽히 처음부터 업데이트 
  this.reset();
  _munge.call(this);
  _scale.call(this);
  _map.call(this, this.container());
  _mark.call(this); 
  // _tooltip.call(this);
}

MarkerMap.prototype.renderLayout = renderLayout;
MarkerMap.prototype.update = update;
MarkerMap.prototype.isSized = isSized;

setMethodsFromAttrs(MarkerMap, _attrs);

export default _markerMap;
export {conditions, latMeasure, lngMeasure};



// WEBPACK FOOTER //
// ../node_modules/daisy-chart/src/layouts/marker-map/index.js